// extracted by mini-css-extract-plugin
export default {"smallCard":"CardGrid_smallCard__AUIk2"};